// extracted by mini-css-extract-plugin
export var dark = "v_rk";
export var darkcookie = "v_rl";
export var tintedcookie = "v_rm";
export var regularcookie = "v_rn";
export var darkbase = "v_rp";
export var tintedbase = "v_rq";
export var regularbase = "v_rr";
export var darkraw = "v_rs";
export var tintedraw = "v_rt";
export var regularraw = "v_rv";
export var darkchick = "v_rw";
export var tintedchick = "v_rx";
export var regularchick = "v_ry";
export var darkherbarium = "v_rz";
export var tintedherbarium = "v_rB";
export var regularherbarium = "v_rC";
export var darkholiday = "v_rD";
export var tintedholiday = "v_rF";
export var regularholiday = "v_rG";
export var darkoffline = "v_rH";
export var tintedoffline = "v_rJ";
export var regularoffline = "v_rK";
export var darkorchid = "v_rL";
export var tintedorchid = "v_rM";
export var regularorchid = "v_rN";
export var darkpro = "v_rP";
export var tintedpro = "v_rQ";
export var regularpro = "v_rR";
export var darkrose = "v_rS";
export var tintedrose = "v_rT";
export var regularrose = "v_rV";
export var darktimes = "v_rW";
export var tintedtimes = "v_rX";
export var regulartimes = "v_rY";
export var darkwagon = "v_rZ";
export var tintedwagon = "v_r0";
export var regularwagon = "v_r1";